import React, { useState } from "react";
import { login } from "./../modules/server";
import { useNavigate } from "react-router-dom";
import { logAndNotifyError, logDebugSilently } from "../modules/logger";
import { UserInfo } from "../types/user-info";
import PubSub from "pubsub-js";
import { Col, Row } from "react-bootstrap";

interface IProps {
  returnTo: string;
  //onLoggedIn : (info:UserInfo) => void;
}

const Login = (props: IProps) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  const tryLogin = async () => {
    //logDebugSilently(email + " : " + password);
    try {
      setIsLoggingIn(true);
      const loginResult = await login(email, password);
      //logDebugSilently("logged in " + JSON.stringify(loginResult));
      setIsLoggingIn(false);
      // if (props.onLoggedIn) props.onLoggedIn(result);

      if (loginResult.userInfo?.userName) logDebugSilently(loginResult.userInfo.userName + " logged in successfully");
      if (props.returnTo) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        try {
          navigate(props.returnTo);
        } catch (err) {
          let x = err;
        }
      }
    } catch (err: any) {
      const dbgE = err;
      setIsLoggingIn(false);
      //logError("Login failed : " + err.toString());
    }
  };

  return (
    <div>
      {/* className="p-5" style={{ backgroundImage: "url('/MeetingRounds.svg')", backgroundSize: "fill", height: "100vh", position: "relative", backgroundRepeat: "no-repeat" }} */}

      {/* <div className="d-xs-block d-sm-none">XS</div>
      <div className="d-none d-sm-block d-md-none">SM</div>
      <div className="d-none d-md-block d-lg-none">MD</div>
      <div className="d-none d-lg-block d-xl-none">LG</div>
      <div className="d-none d-xl-block d-xxl-none">XL</div>
      <div className="d-none d-xxl-block">XXL</div> */}
      <div className="row">
        <div className="col-2 col-md-3 col-lg-4 col-xs-0 "></div>
        <div className="col-8 col-md-6 col-lg-4 col-xs-12 ">
          <img src="/MeetingRounds.svg" alt="QWTOOL" />
        </div>
      </div>

      <div className="row ">
        <div className="col-2 col-md-3 col-lg-4"></div>
        <div className="col-8 col-md-6 col-lg-4 ps-5 pe-5 pt-4">
          <img className="ms-4 me-4 mt-4" src="/qwtool_ordbild_svart.svg" alt="QWTOOL" />
        </div>
      </div>
      <div className="row">
        {/* <div className="col-2 col-md-3 col-lg-4 col-xs-0 "></div>
        <div className="col-8 col-md-6 col-lg-4 col-xs-12"> */}
        <div className="col-1 col-md-2 col-lg-3 col-xxl-4"></div>
        <div className="col-10 col-md-8 col-lg-6 col-xxl-4">
          <form className="p-5 ">
            {/* style={{ position: "absolute", top: "50%", transform: "translateY(-50%)" }} */}
            <div className="form-floating mb-4">
              <input
                type="email"
                id="form2Example1"
                className="form-control"
                value={email}
                onChange={(event) => {
                  setEmail(event.target.value);
                }}
                placeholder="Email"
              />
              <label className="form-label" htmlFor="form2Example1">
                Email
              </label>
            </div>
            <div className="form-outline mb-4 form-floating">
              <input
                type="password"
                id="form2Example2"
                className="form-control"
                value={password}
                onChange={(event) => {
                  setPassword(event.target.value);
                }}
              />
              <label className="form-label" htmlFor="form2Example2">
                Lösenord
              </label>
            </div>
            <div className="row mb-4">
              <div className="col text-decoration-underline">
                <div role="button" onClick={() => navigate("../UserForgotPassword")}>
                  Har du glömt ditt lösenord?
                </div>
              </div>
            </div>
            <button onClick={tryLogin} disabled={isLoggingIn} type="button" className="btn btn-primary btn-block mb-4">
              {isLoggingIn ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  <span>Loggar in...</span>
                </>
              ) : (
                <>
                  <span>Logga in</span>
                </>
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
